/* @import '../../global/app.css'; */
/* @import '../../global/min-app.css'; */

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins scroll-smooth;
  display: block;
}

.blog-side-nav {
  @apply sticky top-0 w-full;
}


.blog-side-nav-title-container {
  @apply  border-b-2 border-ui-gray-4 w-full;
}

.blog-side-nav-container {
  @apply  list-none m-0;
}

.blog-side-nav-container a {
  @apply visited:text-ui-gray-1 hover:text-medium-blue relative pl-[40px]; 
}

.nav-option {
  @apply text-medium-blue;
}

.nav-option.is-active {
  @apply text-medium-blue relative !important;
}

.nav-option.is-active::before {
  @apply text-medium-blue bg-medium-blue h-4px left-0 w-32px -top-[25%] absolute block;
  content: "\0020"; /* Add a space character before the h2 */
  font-family: 'Font Awesome 5 Free'; /* Replace with your desired font */
  font-weight: 900;
  font-size: 1.25em;
  display: inline-block;
  text-align: center;
  position: absolute;
  transform: translateY(16px);
}

.blog-side-nav-container li {
  @apply list-none mb-16px ;
}

.blog-side-nav-container li:first-child {
  @apply mt-16px;
}

/* Animate in */@keyframes fade-in {
  0% {
    opacity: 0.40;
  }
  100% {
    opacity: 0;
  }
}

.overlay1 {
  @apply bg-white absolute w-full h-full top-0 left-0 z-10 opacity-50;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 200ms;
}

.blog-side-nav.animate .overlay1 {
  animation-name: fade-in;
  animation-delay: 0s;
}